import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export type TLoadOrderPdfService = {
  payload: {
    orderId: string
    modelPdfId: string
    usuarioId: number
    fkUsuarioxDispositivo: string
  }
}

export const loadOrderPdfService = async ({
  payload,
}: TLoadOrderPdfService): Promise<ResponseAPI> => {
  const response = await api.get<ResponseAPI>(
    `/pdf/${payload.usuarioId}/${payload.fkUsuarioxDispositivo}/${payload.orderId}/${payload.modelPdfId}`,
  )
  return response.data
}

export type TLoadBlobOrderPdfService = {
  payload: {
    urlPdfInAws: string
  }
}
